const MainState = {
    watch: [],
    refreshWatch: false,
    channels: [],
    refreshChannels: false
 }
 export default MainState;